import React from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100% !important",
    paddingTop: "5px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "black",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default function AutoCompleteComponent({
  dropdownItems,
  propertyName,
  label,
  onChange,
  currValue,
}) {
  const classes = useStyles();

  console.log(dropdownItems);

  return (
    <Autocomplete
      value={currValue}
      className={classes.root}
      options={dropdownItems}
      getOptionLabel={(option) => option[propertyName] || ""}
      style={{ width: 300 }}
      onChange={onChange}
      defaultValue={
        dropdownItems.length === 1
          ? dropdownItems.find((v) => v[propertyName][0])
          : null
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputLabelProps={{ style: { color: "#82B288" } }}
        />
      )}
    />
  );
}
